// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.contact {
  padding-top: 24px;
}
.contact-header {
  margin-bottom: 32px;
}
@media only screen and (min-width: 768px) {
  .contact-header {
    padding: 0 !important;
    padding: 0 30px;
  }
}
.contact-header__title {
  font-size: 36px;
  font-weight: 700;
  line-height: 120%;
}
@media only screen and (min-width: 768px) {
  .contact-header__title {
    font-size: 44px;
    line-height: 120%;
  }
}
@media only screen and (min-width: 1440px) {
  .contact-header__title {
    font-size: 36px;
    line-height: 150%;
  }
}
.contact-header__subtitle {
  height: 48px;
  color: var(--primary-black, #000);
  font-style: normal;
  font-weight: 400;
  line-height: 150%;
}
@media only screen and (min-width: 1440px) {
  .contact-header__subtitle {
    font-size: 18px;
    line-height: 27px;
  }
}
.contact .form {
  padding: 0 30px;
}
@media only screen and (min-width: 768px) {
  .contact .form {
    padding: 0 36px 0 40px;
  }
}
.contact .form-label {
  line-height: 150%;
  font-weight: 400;
}
.contact .form-placeholder {
  color: #B7B9C9;
  font-size: 14px;
  line-height: 150%;
  height: 60px;
  border: none;
  background-color: #f2f2f7;
}
.contact .form button {
  margin-top: 24px;
  border-radius: 50px;
  width: 100%;
  margin-bottom: 50px;
  font-size: 18px;
  font-weight: 500;
  border: none;
  background-color: #FCAF17;
  height: 56px;
}
.contact .form button p {
  margin: auto;
}
.contact .form button.disabled {
  opacity: 0.5;
}
.contact .form img {
  height: 774px !important;
  width: 100%;
}
@media only screen and (min-width: 1440px) {
  .contact .form img {
    height: 793px;
  }
}
.contact .form textarea {
  height: 145px;
}
.contact .info {
  padding: 0 30px;
  margin: 0;
  background-color: #F2F2F7;
  margin-top: 24px;
}
.contact .info-item {
  display: flex;
  gap: 16px;
  margin-bottom: 28px;
}
@media only screen and (min-width: 768px) {
  .contact .info-item {
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 28px;
  }
}
.contact .info-item__text {
  font-size: 14px;
  font-weight: 700;
  line-height: 140%;
  max-width: 100%;
}
@media only screen and (min-width: 768px) {
  .contact .info-item__text {
    width: 290px;
    font-size: 14px;
    font-weight: 700;
    line-height: 140%;
    text-align: center;
    margin-top: 24px;
  }
}
@media only screen and (min-width: 1440px) {
  .contact .info-item__text {
    font-size: 20px;
    font-weight: 600;
    line-height: 150%;
  }
}
.contact .info-item__icon {
  width: 24px;
  height: 24px;
}
@media only screen and (min-width: 768px) {
  .contact .info-item__icon {
    width: 32px;
    height: 32px;
  }
}
@media only screen and (min-width: 1440px) {
  .contact .info-item__icon {
    width: 55px;
    height: 55px;
  }
}
.contact .content {
  max-width: 100%;
  margin: auto;
}
@media only screen and (min-width: 768px) {
  .contact .content {
    display: flex;
  }
}
.contact .content img {
  height: 232px;
  width: 100%;
}
@media only screen and (min-width: 768px) {
  .contact .content img {
    height: 774px;
  }
}
.contact .content .mapCol {
  padding: 0;
}
@media only screen and (min-width: 1440px) {
  .contact .content .mapCol {
    padding-left: 96px;
  }
}

.form-success {
  background-color: #32B16E;
  color: white;
  height: 48px;
  display: flex;
  justify-content: start;
  align-items: center;
}
.form-success img {
  margin-right: 15px;
  margin-left: 40px;
}

.modal-footer button {
  background-color: #FCAF17;
  width: 100%;
  border: none;
  color: black;
  border-radius: 50px;
  opacity: 1 !important;
}
.modal-footer button:active {
  background-color: #FCAF17 !important;
  color: black !important;
}
.modal-footer button:hover {
  background-color: #FCAF17;
  color: black;
}

.modal-header {
  justify-content: center !important;
  border-bottom: 0;
}

.modal-content {
  height: 511px !important;
}
.modal-content .btn-close {
  position: absolute;
  right: 15px;
  border: 2px solid #FCAF17;
  font-size: 12px;
  opacity: 1;
  padding: 10px;
}

.modal-title {
  font-weight: 600 !important;
}

.modal-backdrop.show {
  opacity: 0.7 !important;
}`, "",{"version":3,"sources":["webpack://./src/pages/styles/Contact.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;AACF;AACE;EACE,mBAAA;AACJ;AACI;EAHF;IAII,qBAAA;IACA,eAAA;EAEJ;AACF;AAAI;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;AAEN;AAAM;EALF;IAMI,eAAA;IACA,iBAAA;EAGN;AACF;AADM;EAVF;IAWI,eAAA;IACA,iBAAA;EAIN;AACF;AADI;EACE,YAAA;EACA,iCAAA;EACA,kBAAA;EACA,gBAAA;EACA,iBAAA;AAGN;AADM;EAPF;IAQI,eAAA;IACA,iBAAA;EAIN;AACF;AAAE;EACE,eAAA;AAEJ;AAAI;EAHF;IAII,sBAAA;EAGJ;AACF;AADI;EACE,iBAAA;EACA,gBAAA;AAGN;AAAI;EACE,cAAA;EACA,eAAA;EACA,iBAAA;EACA,YAAA;EACA,YAAA;EACA,yBAAA;AAEN;AACI;EACE,gBAAA;EACA,mBAAA;EACA,WAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;EACA,yBAAA;EACA,YAAA;AACN;AACM;EACE,YAAA;AACR;AAEM;EACE,YAAA;AAAR;AAII;EACE,wBAAA;EACA,WAAA;AAFN;AAIM;EAJF;IAKI,aAAA;EADN;AACF;AAII;EACE,aAAA;AAFN;AAME;EACE,eAAA;EACA,SAAA;EACA,yBAAA;EACA,gBAAA;AAJJ;AAMI;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AAJN;AAMM;EALF;IAMI,sBAAA;IACA,uBAAA;IACA,mBAAA;IACA,gBAAA;EAHN;AACF;AAKM;EACE,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,eAAA;AAHR;AAKQ;EANF;IAOI,YAAA;IACA,eAAA;IACA,gBAAA;IACA,iBAAA;IACA,kBAAA;IACA,gBAAA;EAFR;AACF;AAIQ;EAfF;IAgBI,eAAA;IACA,gBAAA;IACA,iBAAA;EADR;AACF;AAIM;EACE,WAAA;EACA,YAAA;AAFR;AAIQ;EAJF;IAKI,WAAA;IACA,YAAA;EADR;AACF;AAGQ;EATF;IAUI,WAAA;IACA,YAAA;EAAR;AACF;AAKE;EACE,eAAA;EACA,YAAA;AAHJ;AAKI;EAJF;IAKI,aAAA;EAFJ;AACF;AAII;EACE,aAAA;EACA,WAAA;AAFN;AAIM;EAJF;IAKI,aAAA;EADN;AACF;AAII;EACE,UAAA;AAFN;AAIM;EAHF;IAII,kBAAA;EADN;AACF;;AAOA;EACE,yBAAA;EACA,YAAA;EACA,YAAA;EACA,aAAA;EACA,sBAAA;EACA,mBAAA;AAJF;AAME;EACE,kBAAA;EACA,iBAAA;AAJJ;;AAQA;EACE,yBAAA;EACA,WAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,qBAAA;AALF;AAOE;EACE,oCAAA;EACA,uBAAA;AALJ;AAQE;EACE,yBAAA;EACA,YAAA;AANJ;;AAUA;EACE,kCAAA;EACA,gBAAA;AAPF;;AAUA;EACE,wBAAA;AAPF;AASE;EACE,kBAAA;EACA,WAAA;EACA,yBAAA;EACA,eAAA;EACA,UAAA;EACA,aAAA;AAPJ;;AAWA;EACE,2BAAA;AARF;;AAWA;EACE,uBAAA;AARF","sourcesContent":[".contact {\n  padding-top: 24px;\n  \n  &-header {\n    margin-bottom: 32px;\n  \n    @media only screen and (min-width: 768px) {\n      padding: 0 !important;\n      padding: 0 30px;\n    }\n\n    &__title {\n      font-size: 36px;\n      font-weight: 700;\n      line-height: 120%;\n\n      @media only screen and (min-width: 768px) {\n        font-size: 44px;\n        line-height: 120%;\n      }\n\n      @media only screen and (min-width: 1440px) {\n        font-size: 36px;\n        line-height: 150%;\n      }\n    }\n\n    &__subtitle {\n      height: 48px;\n      color: var(--primary-black, #000);\n      font-style: normal;\n      font-weight: 400;\n      line-height: 150%;\n\n      @media only screen and (min-width: 1440px) {\n        font-size: 18px;\n        line-height: 27px;\n      }\n    }\n  }\n\n  .form {\n    padding: 0 30px;\n\n    @media only screen and (min-width: 768px) {\n      padding: 0 36px 0 40px;\n    }\n\n    &-label {\n      line-height: 150%;\n      font-weight: 400;\n    }\n\n    &-placeholder {\n      color: #B7B9C9;\n      font-size: 14px;\n      line-height: 150%;\n      height: 60px;\n      border: none;\n      background-color: #f2f2f7;\n    }\n\n    button {\n      margin-top: 24px;\n      border-radius: 50px;\n      width: 100%;\n      margin-bottom: 50px;\n      font-size: 18px;\n      font-weight: 500;\n      border: none;\n      background-color: #FCAF17;\n      height: 56px;\n\n      p {\n        margin: auto;\n      }\n\n      &.disabled {\n        opacity: 0.5;\n      }\n    }\n\n    img {\n      height: 774px !important;\n      width: 100%;\n\n      @media only screen and (min-width: 1440px) {\n        height: 793px;\n      }\n    }\n\n    textarea {\n      height: 145px;\n    }\n  }\n\n  .info {\n    padding: 0 30px;\n    margin: 0;\n    background-color: #F2F2F7;\n    margin-top: 24px;\n\n    &-item {\n      display: flex;\n      gap: 16px;\n      margin-bottom: 28px;\n\n      @media only screen and (min-width: 768px) {\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n        margin-top: 28px;\n      }\n\n      &__text {\n        font-size: 14px;\n        font-weight: 700;\n        line-height: 140%;\n        max-width: 100%;\n\n        @media only screen and (min-width: 768px) {\n          width: 290px;\n          font-size: 14px;\n          font-weight: 700;\n          line-height: 140%;\n          text-align: center;\n          margin-top: 24px;\n        }\n\n        @media only screen and (min-width: 1440px) {\n          font-size: 20px;\n          font-weight: 600;\n          line-height: 150%;\n        }\n      }\n\n      &__icon {\n        width: 24px;\n        height: 24px;\n\n        @media only screen and (min-width: 768px) {\n          width: 32px;\n          height: 32px;\n        }\n\n        @media only screen and (min-width: 1440px) {\n          width: 55px;\n          height: 55px;\n        }\n      }\n    }\n  }\n\n  .content {\n    max-width: 100%;\n    margin: auto;\n\n    @media only screen and (min-width: 768px) {\n      display: flex;\n    }\n\n    img {\n      height: 232px;\n      width: 100%;\n\n      @media only screen and (min-width: 768px) {\n        height: 774px;\n      }\n    }\n\n    .mapCol {\n      padding: 0;\n      \n      @media only screen and (min-width: 1440px) {\n        padding-left: 96px;\n      }\n    }\n  }\n}\n\n\n.form-success {\n  background-color: #32B16E;\n  color: white;\n  height: 48px;\n  display: flex;\n  justify-content: start;\n  align-items: center;\n\n  img {\n    margin-right: 15px;\n    margin-left: 40px;\n  }\n}\n\n.modal-footer button {\n  background-color: #FCAF17;\n  width: 100%;\n  border: none;\n  color: black;\n  border-radius: 50px;\n  opacity: 1 !important;\n\n  &:active {\n    background-color: #FCAF17 !important;\n    color: black !important;\n  }\n\n  &:hover {\n    background-color: #FCAF17;\n    color: black;\n  }\n}\n\n.modal-header {\n  justify-content: center !important;\n  border-bottom: 0;\n}\n\n.modal-content {\n  height: 511px !important;\n\n  .btn-close {\n    position: absolute;\n    right: 15px;\n    border: 2px solid #FCAF17;\n    font-size: 12px;\n    opacity: 1;\n    padding: 10px;\n  }\n}\n\n.modal-title {\n  font-weight: 600 !important;\n}\n\n.modal-backdrop.show {\n  opacity: 0.7 !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
